export default __webpack_public_path__ + "media/images/svg/dog-decor-over-4221dd7d88a5302ad5c0cceea973c892.svg";